var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-container__max-width"},[_c('div',{staticClass:"d-flex align-content-stretch justify-content-between"},[_c('h3',{staticClass:"page-title m-0"},[_vm._v("Documents")]),_c('history',{attrs:{"entity-id":_vm.$wss.getCurrent.id,"domen":_vm.HistoryDomen.COMPANY,"schema":{
				ss4Form: {
					label: 'SS4 Form',
					action: _vm.ChangeActions.fileMeta,
					fileName: 'File name',
					createDate: 'Upload date'
				},
				certificateOfIncorporation: {
					label: 'Certificate of incorporated',
					action: _vm.ChangeActions.fileMeta,
					fileName: 'File name',
					createDate: 'Upload date'
				},
				filingReceipt: {
					label: 'Filling receipt',
					action: _vm.ChangeActions.fileMeta,
					fileName: 'File name',
					createDate: 'Upload date'
				}
			}}})],1),(_vm.docs)?_c('b-tabs',[_c('b-tab',{attrs:{"title":"SS4 Form"}},[_c('company-document',{on:{"save":_vm.uploadDocuments,"delete":_vm.uploadDocuments},model:{value:(_vm.docs.ss4),callback:function ($$v) {_vm.$set(_vm.docs, "ss4", $$v)},expression:"docs.ss4"}})],1),_c('b-tab',{attrs:{"title":"Certificate of incorporated"}},[_c('company-document',{on:{"save":_vm.uploadDocuments,"delete":_vm.uploadDocuments},model:{value:(_vm.docs.certificateOfIncorporation),callback:function ($$v) {_vm.$set(_vm.docs, "certificateOfIncorporation", $$v)},expression:"docs.certificateOfIncorporation"}})],1),_c('b-tab',{attrs:{"title":"Filling receipt"}},[_c('company-document',{on:{"save":_vm.uploadDocuments,"delete":_vm.uploadDocuments},model:{value:(_vm.docs.fillingReceipt),callback:function ($$v) {_vm.$set(_vm.docs, "fillingReceipt", $$v)},expression:"docs.fillingReceipt"}})],1)],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }